import { useEffect } from 'react';

import { getFeatureFlag } from '@/shared/utils/getFeatureFlag';

export default function useLocalFeatureFlag(name: string, defaultValue = false) {
    const storageKey = 'feature_flag_' + name;
    const flagValue = getFeatureFlag(name, defaultValue);

    useEffect(() => {
        if (flagValue === defaultValue) {
            window?.localStorage?.removeItem(storageKey);
        } else {
            window?.localStorage?.setItem(storageKey, JSON.stringify(flagValue));
        }
    }, [storageKey, defaultValue, flagValue]);

    return flagValue;
}
